<div>
    <div>
        <p-selectButton [options]="options" [(ngModel)]="selectedOption"></p-selectButton>
    </div>
    <app-transactions-payment-received *ngIf="selectedOption == 1"></app-transactions-payment-received>
    <app-transactions-vat-report *ngIf="selectedOption == 2"></app-transactions-vat-report>
    <app-transactions-school-invoice *ngIf="selectedOption == 3"></app-transactions-school-invoice>
    <app-transactions-payment-to-school *ngIf="selectedOption == 4"></app-transactions-payment-to-school>
</div>

